import React from 'react';
import styled from '@emotion/styled';
import Link from 'next/link';

import ErrorImage from '../assets/images/error.jpg';
import ContentMediaBlock from '../components/content-media-block';
import Layout from '../components/layout';
import { SectionHeading } from '../components/type';
import { COLORS, URLS, SPACE } from '../constants';
import { withAppProps, withAppProviders } from '../utils/withAppProps';

const imageProps = {
  url: ErrorImage,
  description: 'No vehicles found',
};

const heading = 'We don’t seem to have results for that vehicle.';

const callToAction = {
  label: 'Search again',
  href: URLS.HOME,
};

const StyledLayout = styled(Layout)`
  background-color: ${COLORS.WHITE};
`;

const StyledSectionHeading = styled(SectionHeading)`
  margin-top: ${SPACE.X1};
`;

const StyledLink = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
`;

const NoResults = () => (
  <StyledLayout>
    {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: This JSX tag's 'children' prop expects a single child of type 'null | undefined', but multiple children were provided. */}
    <ContentMediaBlock {...{ imageProps, heading, callToAction }} isReverse>
      <StyledSectionHeading>
        Just a note that having no results isn’t a reflection of the cars safety.
      </StyledSectionHeading>
      <StyledSectionHeading>
        Instead the registration number you’ve looked up might belong to a make or model we don’t list. Please try again
        or try searching by make or model.
      </StyledSectionHeading>
      <StyledSectionHeading>
        If you still can’t find your car or have any questions{' '}
        <StyledLink href="/contact-us">please contact us</StyledLink>.
      </StyledSectionHeading>
    </ContentMediaBlock>
  </StyledLayout>
);

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'res' implicitly has an 'any' type.
const getServerSideProps = withAppProps(({ res, err }) => {
  let statusCode = 404;
  if (res) {
    statusCode = res.statusCode;
  } else if (err) {
    statusCode = err.statusCode;
  }
  return { props: { statusCode } };
});

export default withAppProviders(NoResults);
export { getServerSideProps };
